import { render, staticRenderFns } from "./ReceiveWallet.vue?vue&type=template&id=6316d062"
import script from "./ReceiveWallet.vue?vue&type=script&lang=js"
export * from "./ReceiveWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports